<template>
    <div class="lazy-img" :class="{'has-intersected': intersected}">
        <div class="lazy-img__ctn" :style="{paddingTop: paddingRatio}"></div>
        <img class="lazy-img__elem" :src="srcImage" :alt="alt" :class="imageClasses">
        <span v-if="hasMask" class="lazy-img__mask"></span>
    </div>
</template>

<script>

export default {
  name: 'app-lazy-img',

  props: {
      alt: {
        type: String
      },
      url: {
        type: String
      },
      width: {
        type: Number
      },
      height: {
        type: Number
      },
      img: {
        type: Object
      },
      classes: {
          type: Array
      },
      forcedRatio: {
        type: String,
        default: null
      },
      hasMask: {
        type: Boolean,
        default: false
      }
  },

  computed: {
    imageClasses() {
      let arr = []

      // if(this.hasMask)
      // {
      //   arr = ['has-mask']
      // }
      return [...this.classes, ...arr]
    },
    srcImage() {
      return this.intersected ? this.url : ''
    },
    paddingRatio() {
      return this.forcedRatio ? `${this.forcedRatio}%` : `${this.height / this.width * 100}%`
    }
  },

  data() {
    return {
        observer: null,
        intersected: false
    }
  },

  created()
  {
    
  },

  mounted()
  {
    this.addEventListeners()
  },

  destroyed()
  {
    this.removeEventListeners()
  },

  methods: {
    addEventListeners()
    {
        this.observer = new IntersectionObserver(entries => {
            const image = entries[0]

            if (image.isIntersecting)
            {
                // this.intersected = true
                // Load image here
                const image = new Image()
                image.onload = () => {
                  this.intersected = true
                }

                image.src = this.url

                this.observer.disconnect()
            }
        })

        this.observer.observe(this.$el)
    },

    removeEventListeners()
    {
        this.observer.disconnect()
    },
  }
}
</script>

<style lang="stylus">
.lazy-img
  position relative
  width 100%
  opacity 0
  visibility hidden
  transition visibility 0s, opacity 0.4s $ease-out-quad

  &.has-intersected
    opacity 1
    visibility visible

.lazy-img__ctn
  width 100%
  display block
  background $white

.lazy-img__elem
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  object-fit cover

  // &.has-mask
  //   transform scale(1.05)
  //   transition transform 0.6s $ease-out-quart 0.2s

  //   .has-intersected &
  //     transform scale(1)

.lazy-img__mask
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  background-color $white
  transform-origin bottom left
  will-change transform
  transition transform 0.8s $ease-in-out-quart

  .has-intersected &
    transform scaleY(0)
</style>